var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMotorola(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 46,
    viewBox: "0 0 97 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.4982 6.90002C57.5455 6.90002 64.6673 14.1585 64.6673 22.9994C64.6673 31.8926 57.4265 39.1 48.4982 39.1C39.5699 39.1 32.334 31.8926 32.334 22.9994C32.334 14.1061 39.5703 6.90002 48.4982 6.90002ZM48.4623 26.3749L43.9402 11.4321L38.0854 30.5638H39.1841C39.1841 30.5638 39.9238 27.2357 41.1222 25.2475C41.7766 24.1697 42.784 23.287 44.1315 23.3121C45.081 23.3291 45.9021 23.8472 46.9288 25.2743C47.546 26.1329 48.4964 28.317 48.4964 28.317C48.4964 28.317 49.4468 26.136 50.0662 25.2743C51.0889 23.8472 51.9109 23.3291 52.8622 23.3121C54.2069 23.2866 55.2184 24.1697 55.8702 25.2493C57.0712 27.2352 57.8087 30.5634 57.8087 30.5634H58.9096L53.0513 11.4316L48.5292 26.3749L48.4986 26.4022L48.4623 26.3749Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotorola);
export default __webpack_public_path__ + "static/media/Motorola.a7bf08d798f389108dda582a4388679a.svg";
export { ForwardRef as ReactComponent };